import { PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import LayersOutlinedIcon from '@material-ui/icons/LayersOutlined';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import ExtensionOutlinedIcon from '@material-ui/icons/ExtensionOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import AddIcon from '@material-ui/icons/Add';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import AppsOutlinedIcon from '@material-ui/icons/AppsOutlined';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import VerifiedUserOutlinedIcon from '@material-ui/icons/VerifiedUserOutlined';
import LiveHelpOutlinedIcon from '@material-ui/icons/LiveHelpOutlined';
import EmojiObjectsOutlinedIcon from '@material-ui/icons/EmojiObjectsOutlined';
import NotificationsNoneOutlinedIcon from '@material-ui/icons/NotificationsNoneOutlined';
import BusinessCenterOutlinedIcon from '@material-ui/icons/BusinessCenterOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import { Sidebar, SidebarPage } from '@backstage/core-components';
import {
  FluxSidebarShell,
  useCatalogCount,
  useMyGroupPath,
  usePendingHandoffs,
} from './FluxSidebar';
import { HttpIcon, NavItem, NavSection } from './SidebarNav';

const SidebarContent = () => {
  const pendingHandoffs = usePendingHandoffs();
  const apiCount = useCatalogCount('API');
  const myGroupPath = useMyGroupPath();

  return (
    <FluxSidebarShell>
      <NavSection title="Principal">
        <NavItem icon={HomeOutlinedIcon} to="/" end text="Home" />
      </NavSection>

      <NavSection title="Catálogo">
        <NavItem icon={LayersOutlinedIcon} to="/catalog" text="Catalog" />
        <NavItem icon={PeopleOutlineIcon} to={myGroupPath} text="My Group" />
        <NavItem
          icon={ExtensionOutlinedIcon}
          to="/api-docs"
          text="APIs"
          badge={
            apiCount !== undefined
              ? { kind: 'mono', label: String(apiCount) }
              : undefined
          }
        />
        <NavItem icon={DescriptionOutlinedIcon} to="/docs" text="Docs" />
        <NavItem icon={AddIcon} to="/create" text="Create entity…" dashed />
      </NavSection>

      <NavSection title="Plataforma">
        <NavItem icon={HttpIcon} to="/postflux" text="PostFlux" />
        <NavItem icon={PlayCircleOutlineIcon} to="/videos" text="Videos" />
        <NavItem
          icon={AppsOutlinedIcon}
          to="/applications"
          text="Applications"
        />
        <NavItem
          icon={SwapHorizIcon}
          to="/handoffs"
          text="Handoffs"
          badge={
            pendingHandoffs > 0
              ? { kind: 'warn', label: String(pendingHandoffs), dot: true }
              : undefined
          }
        />
        <NavItem
          icon={VerifiedUserOutlinedIcon}
          to="/stack-policies"
          text="Stack Policies"
        />
        <NavItem
          icon={ShowChartIcon}
          to="/railway-cost"
          text="Railway FinOps"
        />
      </NavSection>

      <NavSection title="Comunidad">
        <NavItem icon={LiveHelpOutlinedIcon} to="/qeta" text="Q&A" />
        <NavItem
          icon={EmojiObjectsOutlinedIcon}
          to="/ai"
          text="AI Assistant"
          badge={{ kind: 'muted', label: 'Beta' }}
        />
      </NavSection>

      <NavSection title="General">
        <NotificationsSidebarItem
          renderItem={({ unreadCount, to, onClick }) => (
            <NavItem
              icon={NotificationsNoneOutlinedIcon}
              to={to}
              onClick={onClick}
              text="Notifications"
              badge={unreadCount > 0 ? { kind: 'dot' } : undefined}
            />
          )}
        />
        <NavItem
          icon={BusinessCenterOutlinedIcon}
          to="/toolbox"
          text="ToolBox"
        />
        <NavItem icon={SettingsOutlinedIcon} to="/settings" text="Settings" />
      </NavSection>
    </FluxSidebarShell>
  );
};

export const Root = ({ children }: PropsWithChildren<{}>) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const className = 'flux-route-create';
    document.body.classList.toggle(className, pathname.startsWith('/create'));
    return () => document.body.classList.remove(className);
  }, [pathname]);

  return (
    <SidebarPage>
      <Sidebar disableExpandOnHover>
        <SidebarContent />
      </Sidebar>
      {children}
    </SidebarPage>
  );
};
